package com.trevorwiebe.timesheet.core.domain.model

enum class UserRole {
    DRIVER,
    DISPATCHER,
    ADMIN
}
